import type { Preference } from '~/models';

import { useSchedule } from '~/composables/useSchedule';

const usePreferenceStore = defineStore('customer-preference', () => {
  const preference = ref<Preference>({
    general: {
      gTag: null,
      countryCode: 'IE'
    },
    company: { name: '' },
    coverArea: {},
    deliveryTimes: {
      monday: { start: '08:00', end: '23:59' },
      tuesday: { start: '08:00', end: '23:59' },
      wednesday: { start: '08:00', end: '23:59' },
      thursday: { start: '08:00', end: '23:59' },
      friday: { start: '08:00', end: '23:59' },
      saturday: { start: '08:00', end: '23:59' },
      sunday: { start: '08:00', end: '23:59' }
    },
    openingTimes: {
      monday: { start: '08:00', end: '23:59' },
      tuesday: { start: '08:00', end: '23:59' },
      wednesday: { start: '08:00', end: '23:59' },
      thursday: { start: '08:00', end: '23:59' },
      friday: { start: '08:00', end: '23:59' },
      saturday: { start: '08:00', end: '23:59' },
      sunday: { start: '08:00', end: '23:59' }
    },
    template: {}
  });

  const setPreference = (payload: Preference): void => {
    preference.value = payload;
  };

  const moneySymbol = computed<string>(() => {
    return preference.value.general.currency?.symbol ?? '€';
  });

  const isRestaurantOpened = computed<boolean>(() => {
    if (!preference.value.general.online) {
      return false;
    }

    return useSchedule(preference.value.openingTimes).inService();
  });

  const inDeliveryTime = computed<boolean>(() => {
    if (!preference.value.general.enableDelivery) {
      return false;
    }

    return useSchedule(preference.value.deliveryTimes).inService();
  });

  const openAt = computed<string>(() => {
    return useSchedule(preference.value.openingTimes).todayTime();
  });

  const deliveryStartsAt = computed<string>(() => {
    return useSchedule(preference.value.deliveryTimes).todayTime();
  });

  const canonicalURL = computed<string>(() => {
    let link = preference.value.company.websiteUrl;

    if (!link) {
      return '';
    }

    if (!/^https?:\/\//i.test(link)) {
      link = 'https://' + link;
    }

    if (link.endsWith('/welcome')) {
      link = link.replace('/welcome', '');
    }

    return link;
  });

  return {
    preference,
    setPreference,
    canonicalURL,
    moneySymbol,
    isRestaurantOpened,
    inDeliveryTime,
    openAt,
    deliveryStartsAt
  };
});

export { usePreferenceStore };
